import { PatrocinioMaster } from '@App/libs/components/CoberturasEspeciaisLogos'
import {
    colors,
    fonts,
    spaces,
    TABLET_SIZE_MIN
} from '@App/static/styles/global'
import styled from 'styled-components'

const CardBody = styled.div`
    display: flex;
    flex-direction: row;
    padding: 24px 0 24px 24px;
    background: #f5f6f8;
    border-radius: 4px;
    width: 100%;
    margin: ${spaces.jotaSpacing44} ${spaces.jotaSpacing44} 0 0;
    box-sizing: border-box;

    & > img {
        border-radius: 4px;
    }

    @media (max-width: ${TABLET_SIZE_MIN}) {
        flex-direction: column;
        margin: ${spaces.jotaSpacing24} ${spaces.jotaSpacing24} 0 0;
    }

    @media (max-width: 1199px) {
        flex-direction: column;
        padding: 24px;
    }
    @media (max-width: 351px) {
        padding: 16px;
    }
`
const ImageContainer = styled.div`
    margin-right: 60px;

    @media (max-width: 1160px) {
        margin-right: 35px;
    }

    @media (max-width: 1199px) {
        margin-right: 0;
        img {
            width: 100%;
            height: 100%;
        }
    }
`
const RightContent = styled.div`
    overflow: hidden;

    .SponsorshipBox-default {
        .FlexColumnFirst {
            min-width: 180px;
            margin-right: 40px;
            max-width: 280px;
        }

        @media (max-width: 1160px) {
            .FlexColumnFirst {
                min-width: 180px;
                margin-right: 20px;
            }
        }
    }

    .SponsorshipBox-3 {
        .FlexColumnFirst {
            margin-right: 40px;
            min-width: 280px;
        }
    }
`
const TextContainer = styled.div`
    padding-right: 24px;

    & > h1 {
        margin: 20px 0 12px;
        ${fonts.jotaHeading02}
        color: ${colors.black.jotaBlack}
    }

    & > h2 {
        color: ${colors.gray.jotaGrayDark};
        ${fonts.jotaBodyLarge}
        margin: 0px 0px 40px;
    }

    @media (max-width: 1199px) {
        & > h1 {
            margin: 60px 0 12px;
        }
    }
    @media (max-width: 501px) {
        & > h1 {
            margin: 24px 0 12px;
        }
        & > h2 {
            margin: 0px 0px 24px;
        }
    }

    @media (max-width: 415px) {
        & > h1 {
            ${fonts.jotaHeading03}
        }
    }
`
const SponsorshipBox = styled.div`
    display: flex;
    align-items: flex-end;
    position: relative;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 1199px) {
        flex-direction: column;
        align-items: baseline;
    }
`
const FlexColumnFirst = styled.div`
    display: flex;
    flex-direction: column;
    width: fit-content;
    overflow: hidden;

    @media (max-width: 1199px) {
        max-width: unset;
        width: 100%;
        margin-bottom: 40px;
        margin-right: 0px;
    }
`
const CarrouselColumn = styled.div`
    width: 100%;

    .swiperContainer {
        position: relative;
    }
`
const TagMaster = styled.div<{ label?: string }>`
    display: flex;
    align-items: center;
    border-radius: 4px;
    border: ${(props) =>
        props.label === PatrocinioMaster
            ? '2px solid rgba(211, 211, 217, 0.4)'
            : '2px solid transparent'};
    width: fit-content;
    padding: ${(props) =>
        props.label === PatrocinioMaster ? '4px 6px' : '6px 0px'};
    margin-bottom: 16px;

    p {
        width: fit-content;
        margin: 0 0 -1px 4px;
        text-transform: uppercase;
        ${fonts.jotaOverlineXSmall}
        color: ${colors.gray.jotaGrayDarker};
        text-align: center;
        line-height: 14px;
        letter-spacing: 0.11px;
    }

    @media (max-width: 1199px) {
        margin-bottom: 8px;
    }
`
const Tag = styled.div`
    padding: 4px 0px;
    margin-bottom: 20px;
    p {
        width: fit-content;
        margin: 0 0 -1px 4px;
        text-transform: uppercase;
        ${fonts.jotaOverlineXSmall}
        color: ${colors.gray.jotaGrayDark};
        text-align: center;
        line-height: 14px;
        letter-spacing: 0.11px;
    }

    @media (max-width: 1199px) {
        padding: 0;
        margin-bottom: 8px;
    }
`
const LogoContainer = styled.div`
    display: flex;

    .swiper {
        width: 100%;
        height: 100%;
    }

    .swiper-slide {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80px !important;
        height: 80px !important;
        border-radius: 4px;
        border: 1px solid #e6e8ed;
        background-color: white;
        flex-shrink: 1;
    }

    .img-container {
        width: 80px;
        height: 80px;
        object-fit: contain;
        display: flex;
        align-items: center;
        display: flex;
        justify-content: center;
    }

    .swiper-slide img {
        width: 70px;
        height: 70px;
        object-fit: contain;
        img {
            object-fit: contain;
            width: 100%;
            height: 100%;
        }
    }
    .swiper-wrapper {
        transition-timing-function: linear;
    }

    @media (max-width: 1160px) {
        .swiper-slide {
            width: 80px !important;
            height: 80px !important;
        }
    }
`
const Logo = styled.div`
    display: flex;
    width: 80px;
    height: 80px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #e6e8ed;
    background-color: #fff;
    margin-right: 16px;

    .img-container {
        width: 70px;
        height: 70px;
        object-fit: contain;
        display: flex;
        align-items: center;
        img {
            object-fit: contain;
            width: 100%;
            height: 100%;
        }
    }
`
const FoggyLayerLeft = styled.div`
    position: absolute;
    width: 50px;
    height: 100%;
    left: -2px;
    z-index: 2;
    background: linear-gradient(
        to right,
        rgba(245, 246, 248, 1) 0%,
        rgba(245, 246, 248, 0.1) 100%
    );
`
const FoggyLayerRight = styled.div`
    position: absolute;
    width: 50px;
    height: 100%;
    right: -1px;
    z-index: 2;
    background: linear-gradient(
        to left,
        rgba(245, 246, 248, 1) 0%,
        rgba(245, 246, 248, 0) 100%
    );
`
const CoberturasEspeciaisImage = styled.div`
    display: flex;
    flex-direction: column;

    & > p {
        ${fonts.jotaOverlineXSmall}
        color: ${colors.gray.jotaGrayDark}
    }
`

export {
    CardBody,
    ImageContainer,
    TextContainer,
    RightContent,
    SponsorshipBox,
    FlexColumnFirst,
    CarrouselColumn,
    TagMaster,
    Tag,
    LogoContainer,
    Logo,
    FoggyLayerLeft,
    FoggyLayerRight,
    CoberturasEspeciaisImage
}
